





















































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import Vue from 'vue';
import Top10Criteria from './top10-criteria.vue';
import statsApi from '@/api/stats.api';
import { IStatTop10ItemModel } from '@/entities';

@Component({})
export default class Top10Table extends Vue {
    @Prop() public items: IStatTop10ItemModel[];
    @Prop({default: false}) public printVersion;
    @Prop({default: true}) public showOfficeColumn;
    @Prop({default: true}) public showAgentColumn;
    @Prop({default: false}) public small;

    public rows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
}
